export default function deepCopy(obj) {
    // In case of premitives
    if (obj === null || typeof obj !== 'object')
        return obj;

    // Date objects should be
    if (obj instanceof Date)
        return new Date(obj.getTime());

    // Handle Array
    if (Array.isArray(obj)) {
        var clonedArr = [];
        obj.forEach(function(element) {
            clonedArr.push(deepCopy(element));
        });
        return clonedArr;
    }

    // Lastly, handle objects
    let clonedObj = new obj.constructor();
    for (var prop in obj)
        if (obj.hasOwnProperty(prop))
            clonedObj[prop] = deepCopy(obj[prop]);
    
    return clonedObj;
}
